// extracted by mini-css-extract-plugin
export default {"Select":"QHEjfYf7iIZIW995tWHw"};